module.exports = __webpack_public_path__ + "static/media/test-delivery-completed@2x.57a63e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test-delivery-completed@2x.png
// module id = 1325
// module chunks = 1